import { OrderItem } from "~/common/types/order";
import { InitiatedReturnItem } from "../useReturnState/useReturnState.types";

export const getInitiatedReturnItemOriginalOrderItem = (
  initiatedReturnItem: InitiatedReturnItem,
  orderItems: OrderItem[] = []
): OrderItem =>
  orderItems.find(({ id }) => id === initiatedReturnItem.orderItemId) ?? {};
